/**
 * Validates store registration form values.
 *
 * @param {{
 *   storeName?: string,
 *   email?: string,
 *   phone?: string,
 *   phoneType?: string,
 *   storeCode?: string,
 *   floorNumber?: string,
 *   password?: string,
 *   city?: string,
 *   state?: string,
 *   pincode?: string
 * }} values
 * @returns {string[]}
 */
export const validateStoreRegister = (values = {}) => {
  const errors = [];
  const storeName = String(values.storeName || '').trim();
  const email = String(values.email || '').trim();
  const phone = String(values.phone || '').trim();
  const phoneType = String(values.phoneType || 'mobile').trim();
  const storeCode = String(values.storeCode || '').trim();
  const floorNumber = String(values.floorNumber || '').trim();
  const city = String(values.city || '').trim();
  const state = String(values.state || '').trim();
  const pincode = String(values.pincode || '').trim();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!storeName) {
    errors.push('Store name is required.');
  } else if (storeName.length > 50) {
    errors.push('Store name cannot exceed 50 characters.');
  }

  if (!email) {
    errors.push('Email is required.');
  } else if (email.length > 50) {
    errors.push('Email cannot exceed 50 characters.');
  } else if (!emailPattern.test(email)) {
    errors.push('Enter a valid email address.');
  }

  if (!phone) {
    errors.push('Phone is required.');
  } else if (phoneType === 'mobile' && !/^[0-9]{10}$/.test(phone)) {
    errors.push('Mobile number must be exactly 10 digits.');
  } else if (phoneType === 'landline' && !/^[0-9]{8,11}$/.test(phone)) {
    errors.push('Landline number must be between 8 and 11 digits.');
  }

  if (!storeCode) {
    errors.push('Store code is required.');
  }
  if (!floorNumber) {
    errors.push('Floor number is required.');
  }

  const password = String(values.password || '').trim();
  if (!password) {
    errors.push('Password is required.');
  } else if (password.length < 10) {
    errors.push('Password must be at least 10 characters.');
  } else if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one capital letter.');
  } else if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one number.');
  } else if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    errors.push('Password must contain at least one special character.');
  }

  if (!city) {
    errors.push('City is required.');
  } else if (city.length > 50) {
    errors.push('City cannot exceed 50 characters.');
  }

  if (!state) {
    errors.push('State is required.');
  } else if (state.length > 50) {
    errors.push('State cannot exceed 50 characters.');
  }

  if (!pincode) {
    errors.push('Pincode is required.');
  }

  return errors;
};
